import { v4 as uuid } from 'uuid';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { authAPI } from '../auth/auth';

export const authenticationBasedQuery = async(args, api, extraOptions) => {
    const requestID = uuid();
    const resp = await fetchBaseQuery({baseUrl: "/api"})(
        args,
        api,
        extraOptions
    )
    
    if(resp.error && resp.error.status === 401) {
        let refreshed = await authAPI.refreshToken();

        if (refreshed) {
            return await authenticationBasedQuery(args, api, extraOptions)
        }
    }
    return {
        ...resp,
        meta: resp.meta && {...resp.meta, requestID}
    };
}

export  const getLinkToPaySession = createApi({
    reducerPath: 'billPaySession',
    baseQuery: authenticationBasedQuery,
    endpoints: (builder) => ({
        getLinkToPaySession: builder.query({
            query: ({shipmentBillID, paymentSystem, currency}) => `/payment/${paymentSystem}/shipment-bills/${shipmentBillID}?currency=${currency}`,
            keepUnusedDataFor: 0,
            transformErrorResponse: (response) => {
                if(response.status === 401) {
                    response.unauthorized = true;   
                }

                return response
            }
        }),
        generateNestPayData: builder.query({
            query: ({shipmentBillID, currency}) => `/payment/nestpay/shipment-bills/${shipmentBillID}/generate-data?currency=${currency}`,
            keepUnusedDataFor: 0,
            transformErrorResponse: (response) => {
                if(response.status === 401) {
                    response.unauthorized = true;   
                }

                return response
            }
        }),
    }),
})

export const { useLazyGetLinkToPaySessionQuery, useLazyGenerateNestPayDataQuery} = getLinkToPaySession;